import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  generalInfo: {
    borderRadius: '6px',
    backgroundColor: '#F8F4F2',
    marginBottom: theme.spacing(4),
    '& > div:last-of-type > div': {
      borderRight: 0
    }
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRight: '1px solid #C4C4D1',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  item: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  amount: {
    marginBottom: theme.spacing(2),
    '& > div': {
      fontFamily: 'Tiempos Headline',
      fontSize: '50px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '28px'
    }
  },
  label: {
    marginTop: theme.spacing(1)
  }
}))
